import classNames from "classnames"

export function SidePanelDivider({ pad = true }: { pad?: boolean }) {
    return (
        <div
            className={classNames("w-full", {
                "px-3": pad,
            })}
        >
            <div className="w-full h-px bg-gray-700" />
        </div>
    )
}
